import {httpClient} from "./httpClient";

export type GetContractDomainResponse = {
    domain: string;
    is_working: boolean;
};

export async function getContractDomain(): Promise<GetContractDomainResponse> {
    const {data} = await httpClient.get<GetContractDomainResponse>("/contract/getDomain");
    return data;
}

export type SetContractDomainPayload = {
    domain: string;
};

export type SetContractDomainResponse =
    | { success: true }
    | { success: false; error: string };

export async function setContractDomain(
    payload: SetContractDomainPayload
): Promise<SetContractDomainResponse> {
    const {data} = await httpClient.post<SetContractDomainResponse>(
        "/contract/setDomain",
        payload
    );
    return data;
}

